import { FC, memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import cx from 'classnames';

import { LayoutNavbarMenuContainer } from './MenuContainer';
import useWindowSize from '../../../hooks/useWindowSize';
import { storeName } from '../../../redux/models/layout.model';

import './styles.scss';

const LayoutNavbar: FC = () => {
  const { size } = useWindowSize();

  const { navbarFolded, navbarExpand } = useSelector((state) => state[storeName].navbarConfig);
  const dispatch = useDispatch();

  return (
    <>
      <div
        className={cx('clik-inventory__navbar-mask', {
          'clik-inventory__navbar-mask--show': navbarExpand,
        })}
        onClick={() => dispatch[storeName].toggleNavbarConfig(!navbarExpand)}
      />
      <div
        className={cx('clik-inventory__navbar', {
          'clik-inventory__navbar--folded': navbarFolded,
          'clik-inventory__navbar--expand': navbarExpand,
        })}
        onMouseEnter={() => !navbarExpand && dispatch[storeName].setNavbarFolded(false)}
        onMouseLeave={() => !navbarExpand && dispatch[storeName].setNavbarFolded(true)}
      >
        <div
          className={cx('navbar__content-wrapper', {
            'navbar__content-wrapper--expand': true,
          })}
        >
          <div className="navbar__content">
            <header className="content__header">
              <div className="header__wrapper">
                <div className="header__info">
                  <i className="icon-logo_clik_60x68">
                    <span className="path1" />
                    <span className="path2" />
                  </i>
                  <p>CLIK</p>
                  <div className="info__badge">
                    <span>Inventory</span>
                  </div>
                </div>
              </div>
              <i
                className="icon-menu_hamburger_24x24 header__action"
                onClick={() => {
                  if (size.width > 1200) dispatch[storeName].setNavExpand(!navbarExpand);
                  else dispatch[storeName].toggleNavbarConfig(!navbarExpand);
                }}
              />
            </header>
            <div className="content__menu">
              <LayoutNavbarMenuContainer />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const LayoutNavbarMemo = memo(LayoutNavbar);
export { LayoutNavbarMemo as LayoutNavbar };
